<template>
  <div class="gd-modal">
    <div class="gd-modal__bckg" @click="closeModal()"></div>
    <div class="gd-modal__body">
      <div class="gd-modal__title">
        Enregistrer la configuration <b>{{configuration.conf.name}}</b>
        <button
          class="gd-rounded-btn gd-modal__close"
          @click="closeModal()">
          <IconClose class="gd-rounded-btn__icon"></IconClose>
        </button>
      </div>
      <div class="gd-modal__content">
        <form id="putConfigurationForm"
              @submit.prevent="validateForm(chekUserAndUploadConfiguration)">
          <!--formulaire pour checker user-->
          <i class="loader loader--medium" v-if="testing"></i>
          <div v-else>
            <!--SIRET-->
            <label for="siretInput">SIRET lié à l'organisation</label>
            <input
              type="number"
              minlength="14"
              maxlength="14"
              id="siretInput"
              name="siret"
              placeholder=""
              v-model="userCheck.siret"
              required
              class="gd-input-text gd-input-text--full-width"/>

            <!--LOGIN-->
            <label for="loginInput">Login utilisateur</label>
            <input
              id="loginInput"
              name="login"
              placeholder=""
              v-model="userCheck.challenge.login"
              required
              class="gd-input-text gd-input-text--full-width"/>

            <!--PASSWORD-->
            <label for="passwordInput">Mot de passe</label>
            <input
              type="password"
              id="passwordInput"
              name="siret"
              placeholder=""
              v-model="userCheck.challenge.password"
              required
              class="gd-input-text gd-input-text--full-width"/>

            <label for="metaType" class="gd-label big">
              Environnement DeskRH:
            </label>
            <select
              name="metaType"
              id="metaType"
              required
              v-model="selectedEnvironment"
              class="gd-select">
              <option
                v-for="env in environments"
                :value="env.id"
                :key="env.id">
                {{ env.name }}
              </option>
            </select>
          </div>

          <div v-show="!testing" class="gd-text-center">
            <button :disabled="testing" class="gd-default-btn">
              Vérifier l'utilisateur et envoyer la configuration
            </button>
          </div>
          <slot></slot>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import IconClose from '@/assets/svg/icon-close.svg';

export default {
  name: 'SaveConfigurationToDeskRH',
  components: {
    IconClose,
  },
  props: {
    configuration: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      testing: false,
      userCheck: {
        siret: '',
        challenge: {
          login: '',
          password: '',
        },
        environment: '',
      },
      environments: [
        { id: 0, name: 'http://deskrh.fr' },
        { id: 1, name: 'https://preprod.deskrh.fr' },
        { id: 2, name: 'http://amtrust.deskrh.fr' },
        { id: 3, name: 'http://demo.deskrh.fr' },
      ],
      selectedEnvironment: -1,
    };
  },
  methods: {
    ...mapActions({
      checkUserAndUploadConf: 'lad/checkUserAndUploadConf',
    }),

    validateForm(callback) {
      this.$validator.validateAll().then((success) => {
        if (success) {
          callback();
        } else {
          console.log('form not valid');
        }
      });
    },

    chekUserAndUploadConfiguration() {
      this.testing = true;

      if (this.environments[this.selectedEnvironment].name.includes('preprod')) {
        this.userCheck.environment = this.environments[this.selectedEnvironment].name;
      } else { // sinon on enleve le https (pb avec le cache du navigateur)
        this.userCheck.environment = this.environments[this.selectedEnvironment].name.replace('https', 'http');
      }

      console.log(`environment selected => ${JSON.stringify(this.userCheck)}`);
      this.checkUserAndUploadConf({
        userCheck: this.userCheck,
        fileType: this.configuration.fileType,
        configuration: this.configuration.conf,
      })
        .then((data) => {
          this.testing = false;
          if (data.status === 200) {
            this.closeModal();
          } else {
            console.log(`Route n'a pas renvoyé un code 200 =>${data.status}`);
          }
        });
    },
    closeModal() {
      this.testing = false;
      this.$emit('closeModal');
    },
    resetUser() {
      this.userCheck = { siret: '', challenge: { login: '', password: '' }, environment: '' };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SaveConfigurationToDeskRH.vue